<template>
  <div class="trade-offline-detail-page" :class = "{'clear-header':isWechatBrowser}">
    <my-header v-if="!isWechatBrowser" title="申请退款" :showBack="true"></my-header>
    <div v-if="tradeOrder.amount" class="offline-top-bg">
      <div class="title">
        实际应退款金额&nbsp;&nbsp;&nbsp;¥{{tradeOrder.amount}}元
      </div>
    </div>
    <div class="info general-box-shadow">
      <div class="trade-offline-info" style="border: none">
        <div class="input-group border-top-style">
          <div class="input-label">退款原因</div>
          <input class="mint-field-core form-input" type="text" v-model="refundReason" placeholder="请输入退款原因">
        </div>
        <div class="offline-info-item">
          <div class="info-field-name">订单类型:</div><div>商城订单</div>
        </div>
        <div class="offline-info-item">
          <div class="info-field-name">订单状态:</div><div>{{orderStatusMap[tradeOrder.status]}}</div>
        </div>
        <div class="offline-info-item">
          <div class="info-field-name">订单编号:</div><div>{{tradeOrder.orderNo}}</div>
        </div>
        <div class="offline-info-item">
          <div class="info-field-name">下单时间:</div><div>{{tradeOrder.createTime}}</div>
        </div>
        <div class="offline-info-item" v-if="tradeOrder.payTime">
          <div class="info-field-name">支付时间:</div><div>{{tradeOrder.payTime}}</div>
        </div>
        <div class="offline-info-item">
          <span class="info-field-name">订单金额:</span><span>¥{{tradeOrder.amount}}</span>
        </div>
      </div>
    </div>
    <div class="form-btn" @click="orderRefund" >提交</div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import tradeOrderService from '../../service/trade/TradeOrderService'

  export default {
    name: 'OrderRefund',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        tradeOrderId:'',
        tradeOrder:{},
        orderStatusMap:[],
        refundReason:'',
        isWechatBrowser:this.$verfyBrowserType()
      }
    },
    created(){
      this.tradeOrderId = this.$route.query.tradeOrderId;
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getTradeOrderDetail();
    },
    methods: {
      async getTradeOrderDetail(){
        let {code,msg,data} = await tradeOrderService.detail(this.tradeOrderId);
        if(code == '0'){
          console.info(data)
          this.tradeOrder = data.order;
          console.info('this.tradeOrder',this.tradeOrder)
          this.orderStatusMap = data.statusMap;
        }else {
          Toast(msg);
        }
      },
      async orderRefund(){
        let {code,msg,data} = await tradeOrderService.refundOrder(this.tradeOrderId,this.refundReason);
        if(code == '0'){
          Toast('申请退款成功!');
          this.$router.go(-1);
        }else {
          Toast(msg);
        }
      }
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .trade-offline-detail-page {
    height: 100vh;
    background: white;
    font-size: 0.32rem;
    .offline-top-bg{
      height: 1.06rem;
      background-image: url(../../assets/appointment/icon-top-bg.png);
      .title{
        padding-top: 0.28rem;
        padding-left: 0.3rem;
        font-size: 0.36rem;
      }
    }
    .info{
      width: 6.90rem;
      margin: 0.3rem 0.2rem 0 0.3rem;
      .input-group{
        height: 0.96rem;
        display: block;
        padding-bottom: 0.1rem;
        border-bottom: 1px solid #e0dedc;
        .input-label{
          width: auto;
          margin-top: 0.3rem;
          font-size: 0.28rem;
          font-weight: normal;
          font-stretch: normal;
          color: #7f7d7c;
        }
        .form-input{
          width: 6.9rem;
          height: 0.5rem;
          margin: 0 auto;
          line-height: 0.69rem;
          font-size: 0.32rem;
          background-color: white;
        }
      }
    }
    .offline-btn-group{
      display: flex;
      justify-content: flex-end;
      margin-top: 0.42rem;
      margin-right: 0.6rem;
    }
    .general-btn{
      margin-left: 0.2rem;
    }
  }
</style>
